// extracted by mini-css-extract-plugin
module.exports = {"indicator":"CinePlayer-styles-module--indicator--1xHEi"};